module.exports = __webpack_public_path__ + "img/6.55aef0e6.png";